import { onBeforeUnmount } from 'vue';
import { hideIntercomLauncher, showIntercomLauncher } from '@/lib/analytics';

/**
 * For fixed bottom sheets: hides the Intercom launcher while the sheet is
 * open and restores it on close or unmount.
 */
export function useIntercomLauncher() {
	let hidden = false;

	const setSheetOpen = (open) => {
		if (!!open === hidden) return;
		hidden = !!open;
		if (hidden) hideIntercomLauncher();
		else showIntercomLauncher();
	};

	onBeforeUnmount(() => setSheetOpen(false));

	return { setSheetOpen };
}
